import { useInView } from "react-intersection-observer";
import useSendDataToGTM from "@features/analytics/hooks/useSendDataToGTM";
import { TrackingObject } from "@features/analytics/utils/types";

export type SendInViewGTMProps = {
  eventsObject?: TrackingObject;
};

export const useSendInViewGTM = ({ eventsObject }: SendInViewGTMProps) => {
  const sendDataToGTM = useSendDataToGTM();
  const { ref } = useInView({
    threshold: 0.2,
    triggerOnce: true,
    onChange: (inView) => {
      if (!inView) return;
      if (!eventsObject) return;

      sendDataToGTM(eventsObject);
    },
  });

  return { ref };
};
